import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CashLoan } from '../Module/CashLoan.model';
import { CashLoanService } from '../service/CashLoan.service';
import { DatePipe } from '@angular/common';
import { ClientService } from '../service/client.service';
import { StateService } from '../service/state.service';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { PaymentDetails } from '../Module/PayementDetails.model';
import { LoaderService } from '../service/loader.service';

@Component({
  selector: 'app-loan-list',
  templateUrl: './loan-list.component.html',
  styleUrls: ['./loan-list.component.css']
})
export class LoanListComponent implements OnInit, OnDestroy {

  loansToDisplay: CashLoan[] = [];
  paymentDetails = { paid: 0, unpaid: 0 };
  currentPage = 1;
  loansPerPage = 40;
  loanSize!: number;
  initialLoanSize!: number;
  pages: number[] = [];
  clientCount!: number;
  selectedStatus: string = '';
  query: string = '';
  selectedDate: string = '';
  isTableLoading: boolean = false;

  constructor(
    private renderer: Renderer2,
    private loanService: CashLoanService,
    private datePipe: DatePipe,
    private clientService: ClientService,
    private stateService: StateService,
    private route: Router,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'your-component-bg');
    this.isTableLoading = true;

    forkJoin({
      clientCount: this.clientService.countClients(),
      loanCount: this.loanService.countLoans(),
      paymentSummary: this.loanService.getPaymentSummary(),
      pagedLoans: this.loanService.getPagedLoans(0, this.loansPerPage, this.query, this.getStatusFilter(), this.selectedDate)
    }).subscribe({
      next: ({ clientCount, loanCount, paymentSummary, pagedLoans }) => {
        this.clientCount = clientCount;
        this.initialLoanSize = loanCount;
        this.paymentDetails = paymentSummary;
        this.loansToDisplay = pagedLoans.content;
        this.loanSize = pagedLoans.totalElements;
        this.pages = Array.from({ length: pagedLoans.totalPages }, (_, i) => i + 1);
        this.currentPage = 1;
        this.isTableLoading = false;
      },
      error: () => {
        this.isTableLoading = false;
        console.error('Error loading data');
      }
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'your-component-bg');
  }

  getStatusFilter(): boolean | null {
    if (this.selectedStatus === 'true') return true;
    if (this.selectedStatus === 'false') return false;
    return null;
  }

  getLoans(page: number): void {
    this.isTableLoading = true;
    this.loanService.getPagedLoans(page, this.loansPerPage, this.query, this.getStatusFilter(), this.selectedDate)
      .subscribe({
        next: data => {
          this.loansToDisplay = data.content;
          this.loanSize = data.totalElements;
          this.pages = Array.from({ length: data.totalPages }, (_, i) => i + 1);
          this.currentPage = page + 1;
          this.isTableLoading = false;
        },
        error: () => {
          this.isTableLoading = false;
        }
      });
  }

  filterLoans(): void {
    this.getLoans(0);
  }

  onPageChange(page: number): void {
    this.getLoans(page - 1);
  }

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.query = inputElement.value;
    this.filterLoans();
  }

  onStatusChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedStatus = selectElement.value;
    this.filterLoans();
  }

  onDateChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.selectedDate = inputElement.value;
    this.filterLoans();
  }

  openClientFormDialog() {
    this.stateService.openClientFormDialog("addCashLoan");
  }

  goToLoanDetails(loan: CashLoan): void {
    const url = `/loanDetails?id=${loan.id}`;
    window.open(url, '_blank');
  }

  goToLoanEdit(loan: CashLoan): void {
    const url = `/updateLoan?id=${loan.id}`;
    window.open(url, '_blank');
  }

  formatCurrency(amount: number): string {
    // Format the number with thousands separator and 2 decimal places
    const formattedNumber = new Intl.NumberFormat('fr-MA', {
      style: 'currency',
      currency: 'MAD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

    return formattedNumber;
  }
}
